import React, { Component } from 'react'
import JobForm from '../../../components/customer_portal/job/JobForm';
import JobDetail from '../../../components/customer_portal/job/JobDetail';
import Box from '@mui/material/Box';
import { Stack, Typography } from '@mui/material';
import PricingTable from '../../../components/customer_portal/job/PricingTable';
import SendMessage from '../../../components/customer_portal/job/SendMessage';
import { isAuth } from '../../../helpers/cookies';
import { get_user_company, get_company_users_list } from '../../../store/user/userSlice';
import { update_job, get_job_detail, proof_log_table, create_send_message } from '../../../store/job/jobSlice';
class JobPageContainer extends Component {
  constructor(props) {
    super(props);
    this.action_type = 1;
    this.selected_process_tab = props.selected_process_tab;
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const processId = params.get('process_id');

    if (processId) {
      this.props.setProcessTab(Number(processId));
      this.props.setProcessHasJobForm(Number(processId));
    }

    const { job_id, job_detail } = this.props;
    const auth = isAuth();
    if (auth && !this.props.user_company) {
      this.props.get_user_company();
    }
    // Fetch company users for assignment dropdown
    const companyId = auth?.company_id;
    if (companyId && this.props.get_company_users_list) {
      this.props.get_company_users_list(companyId);
    }
    if (job_id) {
      if (job_detail && String(job_detail.id || job_detail.job_id) !== String(job_id)) {
        this.props.clearJobDetail();
        this.props.clearJobData();
      }
      this.props.get_job_messages({ job_id: job_id });
      this.props.get_job_detail({ job_id: job_id });
      this.props.proof_log_table({ job_id });
      const company_id = job_detail ? job_detail.company_id : (isAuth() ? isAuth().company_id : null);
      if (company_id) {
        this.props.get_company_process(company_id);
      }
    } else {
      this.props.clearJobDetail();
      this.props.clearJobData();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.job_id && this.props.job_id !== prevProps.job_id) {
      this.props.clearJobDetail();
      this.props.clearJobData();
      this.props.get_job_messages({ job_id: this.props.job_id });
      this.props.get_job_detail({ job_id: this.props.job_id });
      this.props.proof_log_table({ job_id: this.props.job_id });
    }

    const currentCompanyId = this.props.job_detail?.company_id;
    const prevCompanyId = prevProps.job_detail?.company_id;
    if (currentCompanyId && currentCompanyId !== prevCompanyId) {
      this.props.get_company_process(currentCompanyId);
    }

    const currentProcessId = this.props.job_detail?.process_id;
    const prevProcessId = prevProps.job_detail?.process_id;
    if (currentProcessId && (currentProcessId !== prevProcessId || !this.props.job_form)) {
      this.props.setProcessTab(currentProcessId);
      this.props.setProcessHasJobForm(currentProcessId);
    }
  }

  componentWillUnmount() {
    this.props.clearJobDetail();
    this.props.clearJobData();
  }

  handleJobForm = (data) => {
    this.props.setJobData(data);
  }

  handleJobSubmit = async (job_data, selected_company, assigned_to, process_id) => {

    const cleanFileList = (list) => {
      if (!Array.isArray(list)) return [];
      return list.map(item => {
        if (!item) return null;
        if (item instanceof File) return item;
        if (typeof item === 'string') return item;
        if (item.file instanceof File) return item.file;
        if (typeof item.file === 'string') return item.file;
        if (item.file_path) return item.file_path;
        return null;
      }).filter(Boolean);
    };

    const backendData = {
      ...job_data,
      submitted_file: cleanFileList(job_data.submitted_file),
      completed_file: cleanFileList(job_data.completed_file),
      logo_references: cleanFileList(job_data.logo_references),
      job_items: (job_data.job_items || []).map(item => ({
        ...item,
        submitted_file: cleanFileList(item.submitted_file),
        completed_file: cleanFileList(item.completed_file),
        logo_references: cleanFileList(item.logo_references)
      }))
    };

    const params = new URLSearchParams(window.location.search);
    const paramProcessId = params.get('process_id');
    const effectiveProcessId =
      (process_id && !isNaN(Number(process_id))) ? Number(process_id) :
      (paramProcessId && !isNaN(Number(paramProcessId))) ? Number(paramProcessId) :
      (this.props.selected_process_tab && !isNaN(Number(this.props.selected_process_tab))) ? Number(this.props.selected_process_tab) :
      (job_data?.process_id && !isNaN(Number(job_data.process_id))) ? Number(job_data.process_id) :
      (this.props.company_process?.[0]?.process_id || this.props.company_process?.[0]?.id);

    const effectiveCompanyId = selected_company || this.props.selected_company || (isAuth() ? isAuth().company_id : null);

    const action = await this.props.submit_job({
      job_data: backendData,
      company_id: effectiveCompanyId,
      process_id: effectiveProcessId,
      assigned_to: assigned_to
    });
    return action;
  };

  handleJobUpdate = async (arg1, arg2, arg3, arg4) => {
    let job_id, job_data, assigned_to, selected_company;
    if (typeof arg1 === 'object' && arg1 !== null) {
      job_data = arg1;
      job_id = arg2 || this.props.job_id;
      assigned_to = arg3 !== undefined ? arg3 : job_data?.assigned_to;
      selected_company = arg4 || this.props.selected_company;
    } else {
      job_id = arg1 || this.props.job_id;
      job_data = arg2;
      assigned_to = arg3 !== undefined ? arg3 : job_data?.assigned_to;
      selected_company = arg4 || this.props.selected_company;
    }

    const cleanFileList = (list) => {
      if (!Array.isArray(list)) return [];
      return list.map(item => {
        if (!item) return null;
        if (item instanceof File) return item;
        if (typeof item === 'string') return item;
        if (item.file instanceof File) return item.file;
        if (typeof item.file === 'string') return item.file;
        if (item.file_path) return item.file_path;
        return null;
      }).filter(Boolean);
    };

    // 1️⃣ Normalize top-level & item-level files BEFORE saving
    const cleanedData = {
      ...job_data,
      assigned_to: assigned_to !== undefined ? assigned_to : job_data?.assigned_to,
      submitted_file: cleanFileList(job_data?.submitted_file),
      completed_file: cleanFileList(job_data?.completed_file),
      logo_references: cleanFileList(job_data?.logo_references),
      job_items: (job_data?.job_items || []).map(item => ({
        ...item,
        submitted_file: cleanFileList(item.submitted_file),
        completed_file: cleanFileList(item.completed_file),
        logo_references: cleanFileList(item.logo_references)
      }))
    };

    // 2️⃣ (Optional) Sync with Redux so UI stays correct immediately
    this.props.setJobData(cleanedData);

    // 3️⃣ Update Job
    const result = await this.props.update_job({
      job_id,
      job_data: cleanedData,
    });

    return result;
  };



  handleZipDownload = async (job_id, comp_file_list, ref_no) => {
    try {
      const response = await this.props.download_zip_file({
        job_id,
        comp_file_list
      }).unwrap();

      const blob = response.data || response;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      const fileName = ref_no
        ? `${ref_no} - Completed files.zip`
        : "Completed files.zip";

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Zip download failed:", error);
    }
  };

  handleStatusChange = async (payload) => {
    let res = await this.props.create_send_message(payload);
    return res;
  };

  handleJobLogSubmit = async (payload) => {
    let res = await this.props.create_send_message(payload);
    if (create_send_message.fulfilled.match(res)) {
      await this.props.proof_log_table({ job_id: this.props.job_id });
      await this.props.get_job_messages({ job_id: this.props.job_id });
    }
    return res;
  };

  handleSetTabIndex = async (newVal) => {
    this.props.setTabIndex(newVal)
  };

  render() {
    const { mode, job_form, job_data, send_message_loading, tab_index, job_detail, prev_stage, new_stage, proof_log_data } = this.props;
    const company_process = this.props.company_process || [];
    const process =
      company_process.find(p => String(p.id) === String(job_detail?.process_id)) ||
      company_process.find(p => String(p.process_id) === String(job_detail?.process_id)); // fallback

    const effectiveJobForm = (process && process.job_form && Object.keys(process.job_form).length > 0)
      ? process.job_form
      : job_form;

    const canShowApprovalLog = !!(process?.standard_proof || process?.annotated_proof);
    return (
      <Box sx={{
        pt: 0,
      }}>
        <Stack
          direction="row"
          alignItems="stretch" // 'stretch' ensures headers align vertically if they are same height
          spacing={0}
          sx={{ width: '100%', mt: '-5px' }}
        >
          {mode != "detail" ? (
            <JobForm
              mode={mode}
              job_id={this.props.job_id}
              job_form={effectiveJobForm}
              job_data={job_data}
              job_detail={job_detail}
              prev_stage={prev_stage}
              new_stage={new_stage}
              proof_log_data={proof_log_data}
              handleStatusChange={this.handleStatusChange}
              handleJobForm={this.handleJobForm}
              handleJobSubmit={this.handleJobSubmit}
              handleJobUpdate={this.handleJobUpdate}
              handleZipDownload={this.handleZipDownload}
              company_users_list={this.props.company_users_list}
            />
          ) : (
            <JobDetail
              mode={mode}
              job_id={this.props.job_id}
              job_form={effectiveJobForm}
              job_data={job_data}
              job_detail={job_detail}
              proof_log_data={proof_log_data}
              handleZipDownload={this.handleZipDownload}
            />
          )}
        </Stack>
        {mode !== "create" && (
          <>
            <SendMessage
              is_loading={send_message_loading}
              tab_index={tab_index}
              job_id={this.props.job_id}
              action_type={this.action_type}
              proof_log_data={proof_log_data}
              create_send_message={this.handleJobLogSubmit}
              handleSetTabIndex={this.handleSetTabIndex}
              canShowApprovalLog={canShowApprovalLog}
            />
          </>
        )}
      </Box>
    )
  }
}

export default JobPageContainer;
